import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import {
  Header,
  ProductDescription,
  SavingsCard,
  Footer,
  Button,
  Container,
  Font51,
  Font20,
  ContainerTitle,
  ContainerSubTitle,
  CarouselComponent,
  BodyWrapper,
  MobileFooter
} from '../components'
import { withRouter } from 'react-router-dom'
import SecondaryHeader from '../components/SecondaryHeader'
import { Element } from 'react-scroll'
import clientBackgound from '../static/client-background.png'
import demoVideoLappy from '../static/extact-lappy.jpg'
// const scroll = Scroll.animateScroll

const TopImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  z-index: -1;
  & > img {
    width: 340px;
    position: absolute;
    z-index: -1;
    object-fit: contain;
  }
  @media (max-width: 768px) {
    display: none;
  }
`
const TopContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 105px 80px 0px 80px;
  max-width: 1366px;
  margin: 0 auto;
  & > div:nth-child(1) {
    max-width: 700px;
    width: 55%;
    margin: 0 auto;
    & > h1 {
      font-size: 48px;
      line-height: 1.33;
      letter-spacing: -0.5px;
      color: #000000;
    }
    & > p:nth-child(2) {
      font-size: 18px;
      line-height: 1.61;
      letter-spacing: -0.2px;
      padding: 17px 0;
      max-width: 450px;
      & > span {
        color: #4192ec;
        cursor: pointer;
      }
    }
    & > p:nth-child(3) {
      font-size: 12px;
      line-height: normal;
      color: #4da1ff;
      padding: 20px 0 7px 0px;
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
  & > div:last-child {
    width: 45%;
    & > img {
      padding-top: 50px;
      height: auto;
      object-fit: cover;
      width: 100%;
      object-fit: cover;
      transform: scale(1.3);
      position: relative;
    }
  }

  @media (max-width: 992px) {
    padding: 80px 20px 20px 20px;

    & > div > h1 {
      font-size: 38px !important;
    }
    & p {
      font-size: 16px !important;
    }
    & img {
      transform: scale(1) !important;
    }
  }

  @media (max-width: 768px) {
    padding: 30px 20px 20px 20px;
    & > div {
      &:first-child {
        width: 100%;
      }
      &:last-child {
        display: none;
      }
      > h1 {
        font-size: 28px !important;
      }
      & p {
        font-size: 16px !important;
      }
      & img {
        transform: scale(1) !important;
      }
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`

const FormWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 53px;
  & > input {
    width: 290px;
    height: 53px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.1px;
    border-radius: 4px 0 0 4px;
    padding: 17px 0 15px 15px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 6px 12px 0 rgba(0, 0, 0, 0.05);
    border: solid 0.5px rgba(0, 0, 0, 0.05);
    :focus {
      outline: none;
    }
    ::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #666666;
      opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #666666;
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #666666;
    }
  }
  & > button {
    border-radius: 0 4px 4px 0;
  }

  @media (max-width: 768px) {
    display: block;
    & > input {
      width: 100%;
      height: 38px;
      padding: 10px 15px;
    }
    & button {
      margin-top: 10px;
      width: 100%;
      border-radius: 4px;
    }
  }
`

const ImageLeftWrapper = styled.div`
  bottom: 0px;
  position: absolute;
  left: 0px;
  z-index: -1;
  & > img {
    position: absolute;
    width: 100px;
    object-fit: contain;
    left: 0px;
    top: -50px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`

const ProductCards = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: 1366px;
  @media (max-width: 768px) {
    & > div {
      width: 100%;
      margin: 0px auto;
    }
  }
`

const WorkingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 100px 80px 80px;
  max-width: 1366px;
  margin: 0 auto;
  background: #fafbfc;
  & > div {
    max-width: calc(50% - 20px);
  }
  & > div:nth-child(1) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    & > p:nth-child(1) {
      font-size: 38px;
      font-weight: normal;
      line-height: 1.21;
      color: #333333;
      margin: 0;
    }
    & > p:nth-child(2) {
      font-size: 16px;
      font-weight: normal;
      line-height: 1.63;
      letter-spacing: 0.1px;
      color: #999;
      padding: 20px 0;
    }
  }
  & > div:nth-child(2) {
    margin-left: 64px;
    & > div:last-child {
      & > div > div {
        display: none;
      }
    }
  }

  @media (max-width: 992px) {
    padding: 50px 20px 50px;
    & > div:nth-child(2) {
      margin-left: 30px;
    }
  }

  @media (max-width: 768px) {
    display: block;
    & > div:nth-child(2) {
      margin-left: 0px;
    }

    & > div {
      width: 100%;
      max-width: 100%;
    }

    & > :first-child {
      text-align: center;
      display: block !important;
      padding-bottom: 40px;
      & > p:nth-child(1) {
        font-size: 28px !important;
      }
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const BigImage = styled.div`
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  & > div {
    position: relative;
    padding-top: 25px;
    padding-bottom: 67.5%;
    height: 0;
    & > iframe {
      box-sizing: border-box;
      background-image: url(${demoVideoLappy});
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      padding: 12.4% 15.4% 15.4%;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 540px) {
  }
  width: 100%;
  & img {
    max-width: 100%;
  }
`
const Block = styled.div`
  display: flex;
`
const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 64px;
  & > img {
    width: 50px;
    object-fit: contain;
  }
  @media (max-width: 992px) {
    padding-right: 25px;
  }
}
`
const Right = styled.div`
  & > p:first-child {
    font-size: 22px;
    line-height: 1.45;
    letter-spacing: normal;
    color: #333333;
  }
  & > p:last-child {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    color: #999999;
    padding: 10px 0 30px;
  }
  @media (max-width: 992px) {
    & > p:first-child {
      font-size: 20px;
    }
  }
`
const VerticalLine = styled.div`
  width: 1px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 24px;
`

// const SubscriptionWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   width: 100%;
//   max-width: 980px;
//   padding : 100px 0px 40px 0px;
//   &>div:nth-child(1){
//     width: calc(60% - 0px);
//     padding-right: 20px;
//   }
//   }
//   &>div:nth-child(2){
//     width: calc(40% - 0px);
//     padding-left: 20px;
//     @media (max-width: 768px) {
//       padding-left: 0;
//       width: calc(100% - 0px);
//     }
//   }
//   & > div:nth-child(1) {
//     & > p:nth-child(1){
//       font-size: 28px;
//       font-weight: normal;
//       line-height: 1.64;
//       letter-spacing: -0.4px;
//       color: #333333;
//     }
//     & > p:nth-child(2){
//       font-size: 19px;
//       font-weight: 300;
//       line-height: 1.53;
//       color: #999999;
//       @media (max-width: 768px) {
//         font-size: 16px;
//         padding: 10px 0 30px 0;
//       }
//     }
//     }
//   }
//   @media (max-width: 768px) {
//     display: block;
//     padding-top: 20px;
//     &>div:nth-child(1){
//       width: calc(100% - 0px);
//       padding-right: 0;
//     }
//     }
//   }
// `

// const Form = styled.div`
//   display: flex;
//   flex-direction: column;
//   & > div {
//     margin-bottom: 20px;
//     & > input {
//       font-family: Montserrat;
//       font-size: 14px;
//       font-weight: normal;
//       line-height: normal;
//       letter-spacing: 0.1px;
//       width: 100%;
//       background: transparent;
//       border-radius: 4px;
//       border: 1px solid rgba(5, 5, 5, 0.1);
//       ::placeholder {
//         /* Chrome, Firefox, Opera, Safari 10.1+ */
//         color: #666666;
//         opacity: 1; /* Firefox */
//       }

//       :-ms-input-placeholder {
//         /* Internet Explorer 10-11 */
//         color: #666666;
//       }

//       ::-ms-input-placeholder {
//         /* Microsoft Edge */
//         color: #666666;
//       }
//     }
//   }

//   & > button {
//     width: 100%;
//     font-size: 20px;
//     line-height: normal;
//     letter-spacing: normal;
//     color: #ffffff;
//   }
// `
const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33%;

  position: relative;
`

const Enterprise = styled.div`
  flex-direction: column;
  border: solid 1px #e5e5e5;
  border-radius: 3px;
  justify-content: center;
  align-items: center;
  padding: 60px 20px 20px;
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
  text-align: center;
  h2 {
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #2196f3;
    padding-top: 10px;
  }
  p {
    margin: 8px 0;
  }
`

const Save = styled.div`
  position: absolute;
  z-index: 0;
  top: 12px;
  min-width: 84px;
  height: 24px;
  border-radius: 2px;
  text-transform: capitalize;
  background-color: #f0425f;
  font-size: 15px;
  line-height: 1.33;
  letter-spacing: 0.4px;
  color: #ffffff;
  text-align: center;
  padding: 2px 8px;
  align-self: flex-start;
  left: -10px;
  &:before {
    left: 4.9px;
    top: 19px;
    content: '';
    position: absolute;
    border-left: solid 7.3px #9e1e33;
    border-bottom: solid 7.3px transparent;
    border-top: solid 7.3px transparent;
    transform: rotate(-45deg);
  }
`
const OuterWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 980px;
  width: 100%;
  padding-top: 60px;
  & > div:nth-child(2) {
    margin: 0 20px;
  }
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    display: block;
    & > div:nth-child(2) {
      margin: 0;
    }
    & > div {
      padding-bottom: 60px;
      width: 100%;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`

const CarouselWrapper = styled.div`
  height: ${props => (props.height ? props.height : '550px')};
  @media (max-width: 640px) {
    height: auto;
  }
`

const PriceWrapper = styled.div`
  background: rgb(250, 251, 252);
`
const ClientsContainer = styled.section`
  padding-top: 80px;
  background-size: cover;
  background-position: 0 -40px;
  padding-bottom: 40px;
  background-image: url(${clientBackgound});
  @media (max-width: 640px) {
    padding-top: 40px;
  }
`

const HomeWrapper = styled.div`
  position: relative;
`
class Extract extends Component {
  render() {
    return (
      <Fragment>
        <Header type="product" />
        <SecondaryHeader />
        <Element name="overview">
          <HomeWrapper>
            <TopImageWrapper>
              <img src={require('../static/rectangle2.png')} alt="rectangle" />
            </TopImageWrapper>
            <TopContentWrapper>
              <div>
                <h1>Track your product automatically</h1>
                <p>Track sales and available inventory and communicate with suppliers in real-time.</p>
                <p>EMAIL</p>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FormWrapper>
                    <input type="email" name="_replyto" placeholder="your@email.com" required />
                    <input type="hidden" name="_next" value="/" />
                    <Button
                      type="submit"
                      title="Submit"
                      background="#4da1ff"
                      width="160"
                      height="53"
                      transform="capitalize"
                    />
                  </FormWrapper>
                </form>
              </div>
              <div>
                <img src={require('../static/trckr_demo.png')} alt="laptop" />
              </div>
            </TopContentWrapper>
            <ImageLeftWrapper>
              <img src={require('../static/rectangle1.png')} alt="rectangle" />
            </ImageLeftWrapper>
          </HomeWrapper>
        </Element>
        <Element name="features">
          <Container padding={'150px 80px 50px 80px'} background="transparent">
            <Font51>Built to customize your projects </Font51>
            <Font20>Stay Updated about your Distributon Channel with our Advanced Features.</Font20>
            <ProductCards>
              <ProductDescription
                icon={'monitor_inventory.svg'}
                title="Monitor Inventory"
                description="Channel Partners can easily check their Pending & Approved Inventory."
              />
              <ProductDescription
                icon={'float_schemes.svg'}
                title="Float Schemes Directly"
                description="Channel Partners can view these schemes in the app and act accordingly to increase sales."
              />
              <ProductDescription
                icon={'single_channel_partner.svg'}
                title="Single Channel Partner View"
                description="View Profile, Secondaries, Transactions, Closing Stock and their Schemes."
              />
              <ProductDescription
                icon={'sell_return.svg'}
                title="Sell & Return Products"
                description="Channel Partners scan their inventory with built-in distraction-free scanner to make a transaction."
              />
              <ProductDescription
                icon={'publish_important.svg'}
                title="Publish Important Updates"
                description="Keep Channel Partners updated about the new products, price lists, social media and videos!"
              />
              <ProductDescription
                icon={'notify_channel.svg'}
                title="Notify to Channel Partners"
                description="Keep your channel partners updated with in-app notifications!"
              />
            </ProductCards>
          </Container>
        </Element>
        <Element name="howItWorks" style={{ background: '#fafbfc' }}>
          <WorkingWrapper>
            <div>
              <p>How it works?</p>
              <p>
                With trckr you can track, manage and organise product sales, material purchases and other production
                processes.
              </p>
            </div>

            <div>
              <Block>
                <Left>
                  <img src={require('../static/manage_product_ inventory.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Manage Product and the Inventory Levels of the whole Organisation</p>
                  <p>
                    View All the Products, and inventory in the market. Find who owns the inventory in real time.
                    Add/Import new data and export filtered results with single click.
                  </p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/real-time_inventroy.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Real-time inventory tracking through Transactions</p>
                  <p>
                    Check where your inventory is moving in between your channel partners along with the statuses of the
                    transactions. Follow up easily to approve the transactions or reject if they aren't valid. You can
                    also create transaction manually and the inventory will follow. Its that simple!
                  </p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/float_schemes_directly.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Float schemes directly to your channel partners</p>
                  <p>
                    With Advanced targetting you would be able to float schemes to distributors or retailers to the
                    deepest level. Only the assigned partners will be able to view those schemes allowing you to
                    incentivise the most performing partners. Track schemes partner-wise with ease along with their
                    progress!
                  </p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/advanced_reporting.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Advanced Reporting Module</p>
                  <p>
                    If the earlier results are not enough, 8om trcker comes with an advanced reporting module that will
                    allow you to create reports on the go and schedule them to be delivered to your email. No more
                    applying filters and downloading what you need.
                  </p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/advanced_user_management.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Advanced User Management Rights</p>
                  <p>
                    Create new Roles and define the permissions and access rights. Create users and assign them roles.
                    Now all those users will be able to manage their work with access to only those features that you
                    have specified. This hands control back to you!
                  </p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/personalisation.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Want Some Personalisation? 8om trckr has you Covered</p>
                  <p>
                    Define your logo, colors and social media and all your channel partners apps will show those new
                    colors and logos. This adds a lot of personalisation in the application and the partners are able to
                    associate directly with your brand image.
                  </p>
                </Right>
              </Block>
            </div>
          </WorkingWrapper>
        </Element>
        <Container>
          <ContainerTitle>Product Demo</ContainerTitle>
          <ContainerSubTitle>
            Here we provide a short demo of trckr to make it even more simple and understandable for its users.
          </ContainerSubTitle>
          <BigImage>
            <div>
              <iframe
                title="extract video"
                width="806"
                height="436"
                src="https://drive.google.com/file/d/1UH3NOEkqBVKc2A4sIlg5WlHCIk4EdhYB/preview"
                version="3"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
              />
            </div>
          </BigImage>
        </Container>
        <Element name="pricing">
          <PriceWrapper>
            <Container background="rgb(250, 251, 252)">
              <ContainerTitle>Know how much you SAVE</ContainerTitle>
              <OuterWrapper>
                {/* <CardWrapper>
                  <SavingsCard
                    support="Support over forum and email."
                    ipRotation={'Single IP'}
                    dataRetention={'7'}
                    core={'Single'}
                    ram={'Up to 1GB RAM'}
                    savingImage="trial"
                    plan="TRIAL"
                    server="Shared"
                    storage="Shared"
                    projects="1"
                    tasks="5 Tasks"
                    schedulers="1"
                    trial={true}
                    cost={'Cost Free Forever'}
                  />
                  <Button
                    transform="capitalize"
                    type="submit"
                    title="Get Started"
                    background="#4da1ff"
                    width="180"
                    height="53"
                    shadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}
                  />
                </CardWrapper> */}
                <CardWrapper>
                  <Save>SAVE 20%</Save>
                  <SavingsCard
                    support="Chat Support"
                    ipRotation={'Single IP'}
                    dataRetention={'7'}
                    core={'Single'}
                    ram={'Up to 1GB RAM'}
                    savingImage="basic"
                    subTitle="/monthly"
                    plan="BASIC"
                    number="10"
                    server="Shared"
                    storage="Shared"
                    projects="5"
                    tasks="50 Tasks"
                    schedulers="5"
                    cost={'Excluding Tax'}
                  />
                  <Link to="/contact">
                    <Button
                      transform="capitalize"
                      type="submit"
                      title="Request a quote"
                      background="#4da1ff"
                      width="180"
                      height="42"
                      shadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}
                    />
                  </Link>
                </CardWrapper>
                <CardWrapper>
                  <Enterprise>
                    <img src={require('../static/premiumplan.svg')} style={{ marginTop: '-40px' }} alt="compass" />
                    <h2>Enterprise</h2>
                    <p>Contact us to get </p>
                    <p>
                      <b>Customize Plan</b>
                    </p>
                  </Enterprise>

                  <Link to="/contact">
                    <Button
                      transform="capitalize"
                      type="submit"
                      title="Request a quote"
                      background="#4da1ff"
                      width="180"
                      height="42"
                      shadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}
                    />
                  </Link>
                </CardWrapper>
              </OuterWrapper>
              {/*  <SubscriptionWrapper>
                <div>
                  <p>Still not satisfied with the subscription plans Contact Us</p>
                  <p>
                    We know every user is different and so are their needs. We are here always to serve their needs. Let
                    us know if you have any issue and we are on it. for text below Still not satisfied with the
                    subscription plans Contact Us
                  </p>
                </div>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <Form>
                    <Input type="text" name="name" placeholder="Your name" icon={'user'} changeColor={'#2196f3'} />
                    <Input type="text" name="contact" placeholder="Contact" icon={'contact'} changeColor={'#2196f3'} />
                    <Input
                      type="email"
                      name="_replyto"
                      placeholder="your@email.com"
                      icon={'email'}
                      changeColor={'#2196f3'}
                    />
                    <input type="hidden" name="_next" value="/" />
                    <Button
                      title="Send Request"
                      transform="capitalize"
                      type="submit"
                      background="#4da1ff"
                      width="180"
                      height="53"
                      shadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}
                    />
                  </Form>
                </form>
              </SubscriptionWrapper> */}
            </Container>
          </PriceWrapper>
        </Element>
        <ClientsContainer>
          <ContainerTitle>Our Clients</ContainerTitle>
          <CarouselWrapper height={'400px'}>
            <CarouselComponent carouselType="trckr" />
          </CarouselWrapper>
        </ClientsContainer>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}

export default withRouter(Extract)



// WEBPACK FOOTER //
// ./src/pages/Trckr.js